import { module as BaseModule } from "modujs";

const PREFILL_STORAGE_KEY = "freeEstimate_prefillData";
const PREFILL_LOCKED_KEY = "freeEstimate_prefillLocked";

export default class FreeEstimatePrefill extends BaseModule {
  init() {
    const form = this.el.querySelector("form");
    if (!form) return;

    const method = (form.getAttribute("method") || "").toLowerCase();
    const action = form.getAttribute("action") || "";

    if (method !== "get" || !action.includes("/free-estimate")) {
      return;
    }

    form.addEventListener("submit", () => {
      const data = this.collectFilledFields(form);
      try {
        window.sessionStorage.setItem(PREFILL_STORAGE_KEY, JSON.stringify(data));
        window.sessionStorage.setItem(PREFILL_LOCKED_KEY, JSON.stringify([]));
      } catch (e) {
        // ignore
      }
    });
  }

  collectFilledFields(form) {
    const fields = {};
    const elements = form.querySelectorAll("input, select, textarea");

    elements.forEach((el) => {
      if (!el.name || el.disabled) {
        return;
      }
      const type = (el.type || "").toLowerCase();
      if (["button", "submit", "reset", "file", "image"].includes(type)) {
        return;
      }
      if ((type === "checkbox" || type === "radio") && !el.checked) {
        return;
      }
      const value = (el.value || "").trim();
      if (!value) {
        return;
      }
      fields[el.name] = value;
    });

    return fields;
  }
}
